import React, { useState, useRef, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './Navigation.module.scss'
import { ROUTES } from '../../../routes';

export default function Navigation({ closeMenu, addClassName = ''}) {
    const [isElftalDropdownOpen, setIsElftalDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };

    const handleElftalClick = (e) => {
        e.preventDefault();
        setIsElftalDropdownOpen(!isElftalDropdownOpen);
    };

    const handleDropdownItemClick = () => {
        setIsElftalDropdownOpen(false);
        closeMenu();
        scrollToTop();
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsElftalDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <nav className={`${styles.navigation} ${addClassName}`}>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.home.path}>{ROUTES.home.title}</NavLink>
            
            <div className={styles.dropdown} ref={dropdownRef}>
                <button 
                    className={`${styles.navigation__link} ${styles.dropdown__trigger}`} 
                    onClick={handleElftalClick}
                    aria-expanded={isElftalDropdownOpen}
                >
                    {ROUTES.elftal.title}
                    <span className={`${styles.dropdown__arrow} ${isElftalDropdownOpen ? styles.dropdown__arrow__open : ''}`}>▼</span>
                </button>
                {isElftalDropdownOpen && (
                    <div className={styles.dropdown__menu}>
                        <NavLink 
                            onClick={handleDropdownItemClick} 
                            className={styles.dropdown__item} 
                            to={ROUTES.elftal.submenu.eersteElftal.path}
                            id="first-team-link"
                        >
                            {ROUTES.elftal.submenu.eersteElftal.title}
                        </NavLink>
                        <NavLink 
                            onClick={handleDropdownItemClick} 
                            className={styles.dropdown__item} 
                            to={ROUTES.elftal.submenu.reserven.path}
                            id="reserves-link"
                        >
                            {ROUTES.elftal.submenu.reserven.title}
                        </NavLink>
                    </div>
                )}
            </div>

            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.evenementen.path}>{ROUTES.evenementen.title}</NavLink>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.sponsors.path}>{ROUTES.sponsors.title}</NavLink>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.uitslagen.path}>{ROUTES.uitslagen.title}</NavLink>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.matchballen.path}>{ROUTES.matchballen.title}</NavLink>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.over.path}>{ROUTES.over.title}</NavLink>
            <NavLink onClick={() => { closeMenu(); scrollToTop(); }} className={`${styles.navigation__link}`} to={ROUTES.contact.path}>{ROUTES.contact.title}</NavLink>
        </nav>
    )
}
